/**
 * @fileoverview Provide loading presentation for Inbox lists and selected task details. The owning workspace controls request identity and pending state; these placeholders have no authority over task assignment, completion, or available domain actions.
 */

import React from 'react';



export default function InboxLoading({ detail = false }) {
  return (
    <div className={`task-inbox__loading${detail ? ' task-inbox__loading--detail' : ''}`} role="status" aria-label={detail ? 'Loading task details' : 'Loading tasks'}>
      {detail ? (
        <div aria-hidden="true">
          <div className="task-inbox__skeleton-header">
            <span className="task-inbox__loading-label">Task details</span>
            <span className="task-inbox__skeleton-line task-inbox__skeleton-line--heading" />
            <span className="task-inbox__skeleton-line" />
            <span className="task-inbox__skeleton-line task-inbox__skeleton-line--short" />
          </div>
          <div className="task-inbox__skeleton-fields">
            {Array.from({ length: 6 }, (_, index) => (
              <div key={index}>
                <span className="task-inbox__skeleton-line task-inbox__skeleton-line--label" />
                <span className="task-inbox__skeleton-line" />
              </div>
            ))}
          </div>
          <div className="task-inbox__skeleton-header">
            <span className="task-inbox__skeleton-line task-inbox__skeleton-line--title" />
            <span className="task-inbox__skeleton-line" />
            <span className="task-inbox__skeleton-line task-inbox__skeleton-line--short" />
          </div>
        </div>
      ) : (
        <div aria-hidden="true">
          <div className="task-inbox__skeleton-group"><span className="task-inbox__skeleton-line task-inbox__skeleton-line--title" /></div>
          {Array.from({ length: 4 }, (_, index) => (
            <div className="task-inbox__skeleton-row" key={index}>
              <span className="task-inbox__skeleton-icon" />
              <div>
                <span className="task-inbox__skeleton-line task-inbox__skeleton-line--title" />
                <span className="task-inbox__skeleton-line task-inbox__skeleton-line--short" />
                <span className="task-inbox__skeleton-line task-inbox__skeleton-line--label" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
